export default __webpack_public_path__ + "static/media/Headshot_Ridhi.27b86a09.png";